import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReleaseSwitcherService } from '@tix/auth/services';

@Component({
  selector: 'tix-release-switcher',
  templateUrl: './release-switcher.component.html'
})
export class ReleaseSwitcherComponent implements OnInit {
  private redirectRoute = '/';

  constructor(
    private route: ActivatedRoute,
    private releaseSwitcherService: ReleaseSwitcherService
  ) {}

  async ngOnInit() {
    // Get the route parameter that was passed when redirecting here
    const routeParam = this.route.snapshot.queryParamMap.get('route');
    const sourceParam = this.route.snapshot.queryParamMap.get('source');

    if (routeParam) {
      this.redirectRoute = decodeURIComponent(routeParam);
    }

    // Store the source release if provided
    if (sourceParam) {
      this.releaseSwitcherService.setSourceRelease(sourceParam);
    }

    // Set the current release as the target release
    this.releaseSwitcherService.setCurrentReleaseAsTarget();

    // Wait a brief moment to show the loader, then redirect
    setTimeout(() => {
      window.location.href = this.redirectRoute;
    }, 1000);
  }
}
